/**
 * 敏感事件的缓存
 * 因为 post 返回的信息和 scoket 推的 session_monitor 时序不固定，
 * 即两个返回结果相互依赖，但返回顺序又不固定。
 *
 * 例：发消息是 Post 请求，接口未完成返回前，socket 已经返回 session_monitor 事件了。
 * 导致 session_monitor 的消息 id 无法在消息列表中找到相应的消息。
 *
 * 更好的方案：post 带上前端的 messageId，socket 原样返回（注意考虑 嵌套类型！
 * 因为对于前端，嵌套类型对应多个前端 messageId）
 */
class SensitiveCache {
    constructor () {
        this.cache = {}
    }

    add (id, value) {
        if (this.has(id)) {
            throw new Error(`该 id 已存在 ${id}，值为 ${this.get(id)}`)
        }
        this.set(id, value)
    }

    get (id) {
        return this.cache[id]
    }

    has (id) {
        return id in this.cache
    }

    set (id, value) {
        this.cache[id] = value
    }

    remove (id) {
        if (this.has(id)) {
            delete this.cache[id]
        }
    }
}

export default new SensitiveCache
